import type { LucideIcon } from 'lucide-react';

interface SystemLogoProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
}

function SystemLogo({ icon: Icon, title, subtitle }: SystemLogoProps) {
  return (
    <div className="flex items-center gap-2.5">
      <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground">
        <Icon className="size-4" />
      </div>
      <div className="flex min-w-0 flex-col group-data-[collapsible=icon]:hidden">
        <span className="truncate text-sm font-semibold leading-tight">
          {title}
        </span>
        {subtitle && (
          <span className="truncate text-[11px] leading-tight text-muted-foreground">
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
}

export type { SystemLogoProps };
export { SystemLogo };
